// extracted by mini-css-extract-plugin
module.exports = {"container":"narrator_container__2uRHl","narratorFrame":"narrator_narratorFrame__PCxRX","border":"narrator_border__2nOaW"};